import type { MeetingPublic } from '@repo/types/meetings';

import { cn } from '@repo/lib/cn';
import { CheckIcon, CopyIcon, Link2 } from 'lucide-react';
import { useState } from 'react';

import { Button } from '@/components/ui/button';
import { useCopyToClipboard } from '@/hooks/copy-to-clipboard';

interface MeetingRemoteLinkProps {
  meeting: MeetingPublic;
}

export default function MeetingRemoteLink(meetingRemoteLinkProps: MeetingRemoteLinkProps) {
  const { meeting } = meetingRemoteLinkProps;
  const { meetingURL } = meeting;
  const [copied, setCopied] = useState<boolean>(false);

  const [_, copy] = useCopyToClipboard();

  const handleCopy = async () => {
    if (!meetingURL) return;
    try {
      await copy(meetingURL);
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  };

  return (
    <div className={'flex w-full gap-3'}>
      {meetingURL ? (
        <a href={meetingURL} target="_blank" rel="noreferrer">
          <Button variant={'tertiary'}>
            <Link2 />
            Link do spotkania
          </Button>
        </a>
      ) : (
        <Button variant={'tertiary'} disabled>
          Brak linku do spotkania
        </Button>
      )}
      <Button variant="ghost" className="disabled:opacity-100" onClick={() => void handleCopy()} aria-label={copied ? 'Copied' : 'Copy to clipboard'} disabled={copied}>
        <div className={cn('transition-all', copied ? 'scale-100 opacity-100' : 'scale-0 opacity-0')}>
          <CheckIcon className="stroke-icon-success" aria-hidden="true" />
        </div>
        <div className={cn('absolute transition-all', copied ? 'scale-0 opacity-0' : 'scale-100 opacity-100')}>
          <CopyIcon aria-hidden="true" />
        </div>
      </Button>
    </div>
  );
}
